import { useState } from 'react';
import { useRouter } from '@abyss/web/hooks/useRouter';

type TabAddons = {
  index: number;
  title: string;
  code: string;
};

export const ResponseDetailContainerController = () => {
  const { getRouteParams } = useRouter();
  const params = getRouteParams('');

  const [addons] = useState<Array<TabAddons>>([
    { code: 'DETAIL', index: 1, title: 'Detail' },
    { code: 'ACTIVITY_LOG', index: 2, title: 'Activity Log' },
  ]);

  const sourceSessionId = params?.id ?? null;

  return { addons, sourceSessionId };
};
